<template>
    <div class="third-shape-hero-section" v-show="startAnimitionShapeThree">
        <div class="circle-animation-container" v-show="finishLoading">
            <!-- Circle Animation -->
            <div class="circle-effect" :class="{ 'active': showCircleEffect }">
                <div class="click-circle circle-1"></div>
                <div class="click-circle circle-2"></div>
            </div>
        </div>

        <!-- SVG Icon that appears with click effect -->
        <div class="click-indicator-icon " v-show="showIcon" :class="{ 'appear': showIcon }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#5854FF" />
            </svg>
        </div>

        <!-- Content Card -->
        <div class="content-card" v-show="showCard" :class="{ 'appear': showCard }">
            <!-- Card Container -->
            <div class="card-container">
                <!-- Card Background -->
                <div class="card-background"></div>

                <!-- Card Content -->
                <div class="card-content">
                    <!-- Arabic Text with typing effect -->
                    <div class="card-title">
                        <span class="typing-text">{{ displayedText }}</span>
                        <span class="typing-cursor" v-show="isTyping">|</span>
                    </div>

                    <!-- Action Icons -->
                    <div class="action-icons">
                        <!-- Upload Icon -->
                        <div class="upload-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M14 2.8125C17.97 2.8125 19.97 2.8125 21.36 4.2025C22.75 5.5925 22.75 7.5825 22.75 11.5625V13.5625C22.75 17.5325 22.75 19.5325 21.36 20.9225C19.97 22.3125 17.97 22.3125 14 22.3125H10C6.03 22.3125 4.03 22.3125 2.64 20.9225C1.25 19.5325 1.25 17.5425 1.25 13.5625V11.5625C1.25 7.5925 1.25 5.5925 2.64 4.2025C4.03 2.8125 6.03 2.8125 10 2.8125H14ZM3.7 5.2625C2.75 6.2125 2.75 8.0025 2.75 11.5625H2.74V13.5625C2.74 15.0025 2.75 16.1525 2.81 17.0725L5.59 13.9525C6.28 13.1625 7.63 13.1225 8.37 13.8725L10 15.5025L14.13 11.3725C14.86 10.6425 16.18 10.6625 16.9 11.4325L21.23 16.1525C21.25 15.4125 21.25 14.5625 21.25 13.5625V11.5625C21.25 8.0025 21.25 6.2125 20.3 5.2625C19.35 4.3125 17.56 4.3125 14 4.3125H10C6.44 4.3125 4.65 4.3125 3.7 5.2625ZM10 20.8125H14V20.8025C17.56 20.8025 19.35 20.8025 20.3 19.8525C20.7 19.4625 20.93 18.9025 21.06 18.1425L20.95 18.0625L15.8 12.4425C15.64 12.2725 15.35 12.2625 15.19 12.4225L10.53 17.0825C10.25 17.3625 9.75 17.3625 9.47 17.0825L7.31 14.9225C7.27017 14.8847 7.2232 14.8551 7.17183 14.8356C7.12046 14.8161 7.06572 14.807 7.01081 14.8089C6.95589 14.8107 6.9019 14.8235 6.85197 14.8464C6.80204 14.8694 6.75718 14.902 6.72 14.9425L3.15 18.9625C3.28 19.3225 3.46 19.6225 3.7 19.8625C4.65 20.8125 6.44 20.8125 10 20.8125ZM10.75 9.0625C10.75 10.3025 9.74 11.3125 8.5 11.3125C7.26 11.3125 6.25 10.3025 6.25 9.0625C6.25 7.8225 7.26 6.8125 8.5 6.8125C9.74 6.8125 10.75 7.8225 10.75 9.0625ZM9.25 9.0625C9.25 8.6525 8.91 8.3125 8.5 8.3125C8.09 8.3125 7.75 8.6525 7.75 9.0625C7.75 9.4725 8.09 9.8125 8.5 9.8125C8.91 9.8125 9.25 9.4725 9.25 9.0625Z"
                                    fill="black" />
                            </svg>
                        </div>

                        <!-- Gallery Icon -->
                        <div class="gallery-icon" :class="{ 'show-check': showCheckIcon }">
                            <!-- Original Icon -->
                            <svg v-if="!showCheckIcon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="original-icon">
                                <circle cx="12" cy="12" r="12" fill="#5854FF" />
                                <path
                                    d="M7.5 9.75C8.3856 8.991 10.74 6 12 6M12 6C13.26 6 15.6144 8.991 16.5 9.75M12 6V18"
                                    stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <!-- Check Icon -->
                            <svg v-if="showCheckIcon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="check-icon">
                                <circle cx="12" cy="12" r="12" fill="#4CAF50" />
                                <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>

                        <!-- Card Circle Effect -->
                        <div class="card-circle-effect" :class="{ 'active': showCardCircleEffect }">
                            <div class="card-click-circle card-circle-1"></div>
                            <div class="card-click-circle card-circle-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- New Icons (appear after card is hidden) -->
        <!-- Icon 1 -->
        <div class="new-icon-container icon-1" v-show="showNewIcon1" :class="{ 'appear': showNewIcon1 }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_391_37)">
                    <mask id="mask0_391_37" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0"
                        width="24" height="24">
                        <path d="M24 0H0V24H24V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_391_37)">
                        <path
                            d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z"
                            fill="#5854FF" />
                        <path
                            d="M9.22559 17.1429V15.8743H12.5685V6.24004H12.4485L9.43131 9.05147L8.59131 8.1429L11.7627 5.17719H14.0085V15.8743H17.0942V17.1429H9.22559Z"
                            fill="white" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_391_37">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </div>

        <!-- Icon 2 -->
        <div class="new-icon-container icon-2" v-show="showNewIcon2" :class="{ 'appear': showNewIcon2 }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z"
                    fill="#5854FF" />
                <path
                    d="M16 17H8.10345V15.6676L12.0345 12.4141C12.5977 11.9493 13.069 11.4587 13.4483 10.9423C13.8276 10.4155 14.0172 9.88873 14.0172 9.36197V9.17606C14.0172 8.577 13.8333 8.09155 13.4655 7.71972C13.0977 7.34789 12.5402 7.16197 11.7931 7.16197C11.4253 7.16197 11.1034 7.20845 10.8276 7.30141C10.5517 7.39437 10.3103 7.52348 10.1034 7.68873C9.90804 7.85399 9.74138 8.05024 9.60345 8.27746C9.47701 8.49437 9.37356 8.73193 9.2931 8.99014L8 8.54084C8.11494 8.22066 8.27011 7.9108 8.46552 7.61127C8.67241 7.30141 8.92528 7.0277 9.22414 6.79014C9.53448 6.55258 9.9023 6.36151 10.3276 6.2169C10.7644 6.0723 11.2759 6 11.8621 6C12.4483 6 12.9713 6.07746 13.431 6.23239C13.8908 6.38732 14.2759 6.60423 14.5862 6.8831C14.8966 7.16197 15.1322 7.49249 15.2931 7.87465C15.4655 8.2568 15.5517 8.68028 15.5517 9.14507C15.5517 9.56855 15.4828 9.96103 15.3448 10.3225C15.2184 10.684 15.0402 11.03 14.8103 11.3606C14.5805 11.6807 14.2989 11.9958 13.9655 12.3056C13.6437 12.6155 13.2931 12.9254 12.9138 13.2352L9.67241 15.8535H16V17Z"
                    fill="white" />
            </svg>


        </div>

        <!-- Icon 3 -->
        <div class="new-icon-container icon-3" v-show="showNewIcon3" :class="{ 'appear': showNewIcon3 }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z" fill="#5854FF"/>
<path d="M11.311 10.6925C12.0266 10.6925 12.5608 10.53 12.9136 10.205C13.2765 9.86981 13.4579 9.44321 13.4579 8.92521V8.81856C13.4579 8.25993 13.2815 7.84349 12.9287 7.56925C12.586 7.28486 12.1325 7.14266 11.568 7.14266C11.0238 7.14266 10.5803 7.26454 10.2376 7.50831C9.89489 7.74192 9.61267 8.06187 9.39093 8.46814L8.45356 7.73684C8.58459 7.52355 8.74082 7.31533 8.92225 7.11219C9.11375 6.89889 9.33549 6.71099 9.58747 6.54848C9.83945 6.38596 10.1317 6.25392 10.4644 6.15235C10.797 6.05078 11.1749 6 11.5983 6C12.0418 6 12.46 6.06094 12.8531 6.18283C13.2462 6.29455 13.5839 6.46722 13.8661 6.70083C14.1584 6.92428 14.3852 7.2036 14.5464 7.53878C14.7178 7.87396 14.8035 8.25485 14.8035 8.68144C14.8035 9.02678 14.748 9.33657 14.6371 9.6108C14.5364 9.88504 14.3952 10.1237 14.2138 10.3269C14.0324 10.53 13.8157 10.7027 13.5637 10.8449C13.3218 10.9871 13.0598 11.0937 12.7775 11.1648V11.2258C13.0598 11.2867 13.3319 11.3883 13.594 11.5305C13.8661 11.6625 14.103 11.8403 14.3045 12.0637C14.5162 12.277 14.6825 12.5411 14.8035 12.856C14.9345 13.1607 15 13.5111 15 13.9072C15 14.3643 14.9143 14.7858 14.743 15.1717C14.5716 15.5476 14.3297 15.8726 14.0173 16.1468C13.7048 16.4109 13.3269 16.6191 12.8834 16.7715C12.4399 16.9238 11.951 17 11.4168 17C10.9633 17 10.5601 16.9492 10.2073 16.8476C9.85457 16.7461 9.54212 16.609 9.26998 16.4363C8.99784 16.2636 8.75594 16.0706 8.54428 15.8573C8.34269 15.644 8.16127 15.4206 8 15.187L8.95248 14.4557C9.08351 14.669 9.22462 14.862 9.37581 15.0346C9.53708 15.2073 9.71346 15.3546 9.90497 15.4765C10.0965 15.5983 10.3132 15.6948 10.5551 15.7659C10.797 15.8269 11.0792 15.8573 11.4017 15.8573C12.1476 15.8573 12.712 15.6898 13.095 15.3546C13.478 15.0092 13.6695 14.5217 13.6695 13.892V13.7701C13.6695 13.1404 13.478 12.6579 13.095 12.3227C12.712 11.9774 12.1476 11.8047 11.4017 11.8047H10.162V10.6925H11.311Z" fill="white"/>
</svg>


        </div>

        <!-- Icon 4 -->
        <div class="new-icon-container icon-4" v-show="showNewIcon4" :class="{ 'appear': showNewIcon4 }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z" fill="#5854FF"/>
<path d="M15.3916 7.25366L10.0231 7.27713L9.69183 11.7761L9.81464 11.7755C10.1053 11.3797 10.4314 11.0627 10.793 10.8244C11.1662 10.5861 11.6745 10.4655 12.3178 10.4627C12.8441 10.4604 13.3299 10.5428 13.775 10.7099C14.2202 10.8771 14.6073 11.1177 14.9361 11.4319C15.265 11.7348 15.5181 12.1113 15.6955 12.5614C15.8846 13.0114 15.9804 13.5239 15.9829 14.0988C15.9854 14.6736 15.8942 15.2038 15.7092 15.6893C15.5241 16.1635 15.251 16.5761 14.89 16.9271C14.5406 17.2668 14.109 17.5336 13.5952 17.7275C13.0931 17.9213 12.5204 18.0196 11.8771 18.0224C11.3625 18.0247 10.9061 17.9703 10.5079 17.8593C10.1215 17.7483 9.77576 17.5976 9.47082 17.4073C9.16589 17.2171 8.89594 17.0041 8.66098 16.7684C8.43772 16.5327 8.23196 16.2856 8.04368 16.0271L9.14542 15.2107C9.2985 15.4468 9.45734 15.6603 9.62192 15.8512C9.7982 16.042 9.98605 16.2046 10.1855 16.339C10.3966 16.4734 10.6368 16.5794 10.9062 16.6571C11.1755 16.7236 11.4973 16.756 11.8716 16.7544C12.7137 16.7507 13.3502 16.5337 13.7811 16.1035C14.212 15.6733 14.4257 15.0693 14.4223 14.2916L14.4216 14.1225C14.4182 13.3447 14.1992 12.7427 13.7645 12.3162C13.3299 11.8898 12.6915 11.6784 11.8494 11.6821C11.288 11.6845 10.844 11.7879 10.5174 11.9923C10.2024 12.1853 9.91686 12.4176 9.66073 12.6892L8.41436 12.5256L8.82458 6.03119L15.3861 6.0025L15.3916 7.25366Z" fill="white"/>
</svg>

        </div>

        <!-- Icon 5 -->
        <div class="new-icon-container icon-5" v-show="showNewIcon5" :class="{ 'appear': showNewIcon5 }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z" fill="#5854FF"/>
<path d="M11.5193 18C10.824 18 10.1931 17.8986 9.62661 17.6958C9.07296 17.4817 8.59657 17.1831 8.19742 16.8C7.81116 16.4056 7.51502 15.9268 7.30901 15.3634C7.103 14.8 7 14.169 7 13.4704C7 12.5915 7.14807 11.769 7.44421 11.0028C7.74034 10.2254 8.12017 9.52113 8.58369 8.89014C9.06009 8.24789 9.58155 7.68451 10.1481 7.2C10.7146 6.70423 11.2682 6.30423 11.809 6H13.8949C13.1738 6.46197 12.53 6.91268 11.9635 7.35211C11.397 7.79155 10.9013 8.25352 10.4764 8.73803C10.0515 9.21127 9.69099 9.72394 9.39485 10.2761C9.09871 10.8169 8.86052 11.431 8.68026 12.1183L8.77682 12.1521C9.09871 11.6676 9.51073 11.2676 10.0129 10.9521C10.5279 10.6254 11.1974 10.462 12.0215 10.462C12.6009 10.462 13.1352 10.5465 13.6245 10.7155C14.1137 10.8845 14.5322 11.1268 14.8798 11.4423C15.2275 11.7577 15.4979 12.1408 15.691 12.5915C15.897 13.0423 16 13.5437 16 14.0958C16 14.6704 15.8906 15.2 15.6717 15.6845C15.4657 16.1577 15.1631 16.569 14.7639 16.9183C14.3777 17.2563 13.9077 17.5211 13.3541 17.7127C12.8004 17.9042 12.1888 18 11.5193 18ZM11.5 16.7662C12.3884 16.7662 13.0773 16.5521 13.5665 16.1239C14.0687 15.6958 14.3197 15.0817 14.3197 14.2817V14.1465C14.3197 13.3465 14.0687 12.7324 13.5665 12.3042C13.0773 11.8761 12.3884 11.662 11.5 11.662C10.6116 11.662 9.91631 11.8761 9.41416 12.3042C8.92489 12.7324 8.68026 13.3465 8.68026 14.1465V14.2817C8.68026 15.0817 8.92489 15.6958 9.41416 16.1239C9.91631 16.5521 10.6116 16.7662 11.5 16.7662Z" fill="white"/>
</svg>


        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch, onUnmounted } from 'vue'
const props = defineProps({
    startAnimitionShapeThree: {
        type: Boolean,
        required: true
    }
})
const startAnimationRun = ref(false)

const startAnimitionShapeThree = computed(() => props.startAnimitionShapeThree)
watch(startAnimitionShapeThree, (newVal) => {
    if (newVal) {
        startAnimationSequence()
    } else {
        startAnimationRun.value = false
    }
})
// Animation state variables
const finishLoading = ref(false)
const showCircleEffect = ref(false)
const showIcon = ref(false)
const showCard = ref(false)

// Typing effect variables
const displayedText = ref('')
const isTyping = ref(false)
const fullText = 'تسلسل المحتوى يربك المستخدم ويقلل فرص إتمام المهمة.'
let typingInterval: NodeJS.Timeout | null = null
const isAnimationRunning = ref(false)
const showCardCircleEffect = ref(false)
const showCheckIcon = ref(false)
const showNewIcon1 = ref(false)
const showNewIcon2 = ref(false)
const showNewIcon3 = ref(false)
const showNewIcon4 = ref(false)
const showNewIcon5 = ref(false)

// Typing effect function
const typeText = () => {
    // Check if animation is still running
    if (!isAnimationRunning.value) {
        return
    }

    displayedText.value = ''
    isTyping.value = true
    let i = 0

    if (typingInterval) clearInterval(typingInterval)

    typingInterval = setInterval(() => {
        // Check if animation is still running before each character
        if (!isAnimationRunning.value) {
            clearInterval(typingInterval!)
            return
        }

        displayedText.value += fullText[i]
        i++
        if (i >= fullText.length) {
            clearInterval(typingInterval!)
            isTyping.value = false
            // Show circle effect on card after typing is complete
            setTimeout(() => {
                showCardCircleEffect.value = true

                // Show check icon after circle effect completes
                setTimeout(() => {
                    showCheckIcon.value = true
                }, 600) // Wait for circle animation to complete
            }, 1000) // Wait 1 second after typing completes
        }
    }, 80) // typing speed
}

// Animation sequence function
const startAnimationSequence = async () => {
    if (!startAnimitionShapeThree.value || startAnimationRun.value) {
        return
    }
    await new Promise(resolve => setTimeout(resolve, 500))
    startAnimationRun.value = true
    // Set animation as running
    isAnimationRunning.value = true

    // Clear any existing typing interval and reset text
    if (typingInterval) {
        clearInterval(typingInterval)
        typingInterval = null
    }
    displayedText.value = ''
    isTyping.value = false
    showCardCircleEffect.value = false
    showCheckIcon.value = false
    showNewIcon1.value = false
    showNewIcon2.value = false
    showNewIcon3.value = false
    showNewIcon4.value = false
    showNewIcon5.value = false

    // Step 1: Show circle effect only
    showCircleEffect.value = true
    showIcon.value = false
    showCard.value = false

    // Step 2: Wait for circle animation to complete (0.6s)
    await new Promise(resolve => setTimeout(resolve, 600))

    // Step 3: Hide circle effect
    showCircleEffect.value = false

    // Step 4: Show icon
    showIcon.value = true

    // Step 5: Wait for icon animation to complete (0.3s)
    await new Promise(resolve => setTimeout(resolve, 300))

    // Step 6: Show card and start typing
    showCard.value = true

    // Step 7: Start typing effect after card appears
    setTimeout(() => {
        if (isAnimationRunning.value) {
            typeText()
        }
    }, 500)

    // Step 8: Wait for typing to complete and then some extra time
    await new Promise(resolve => setTimeout(resolve, 6700))

    // Step 9: Start fade out animation for card and icon
    showIcon.value = false
    showNewIcon1.value = true
    await new Promise(resolve => setTimeout(resolve, 200))
    showCard.value = false

    showCardCircleEffect.value = false

    // Step 10: Wait for fade out to complete, then show icons one by one
    await new Promise(resolve => setTimeout(resolve, 200))

    // Show first icon


    // Show second icon after 1 second
    setTimeout(() => {
        showNewIcon2.value = true
    }, 400)

    // Show third icon after 2 seconds
    setTimeout(() => {
        showNewIcon3.value = true
    }, 800)

    // Show fourth icon after 3 seconds
    setTimeout(() => {
        showNewIcon4.value = true
    }, 1200)

    // Show fifth icon after 4 seconds
    setTimeout(() => {
        showNewIcon5.value = true
    }, 1600)

    // Step 11: Wait 2 seconds then hide all icons and restart
    await new Promise(resolve => setTimeout(resolve, 6000))

    // Step 12: Hide all icons
    showNewIcon1.value = false
    showNewIcon2.value = false
    showNewIcon3.value = false
    showNewIcon4.value = false
    showNewIcon5.value = false

    // Step 13: Wait 1 second before restart
    await new Promise(resolve => setTimeout(resolve, 1000))

    // Step 11: Restart animation cycle only if still running
    if (isAnimationRunning.value) {
        startAnimationSequence()
    }
    if (isAnimationRunning.value) {
        startAnimationSequence()
    }
}

// Start animation when component mounts
onMounted(() => {
    finishLoading.value = true

    // Start animation sequence after a short delay
    setTimeout(() => {
        startAnimationSequence()
    }, 500)
})

// Stop animation function
const stopAnimation = () => {
    isAnimationRunning.value = false
    if (typingInterval) {
        clearInterval(typingInterval)
        typingInterval = null
    }
    showCircleEffect.value = false
    showIcon.value = false
    showCard.value = false
    displayedText.value = ''
    isTyping.value = false
    showCardCircleEffect.value = false
    showCheckIcon.value = false
    showNewIcon1.value = false
    showNewIcon2.value = false
    showNewIcon3.value = false
    showNewIcon4.value = false
    showNewIcon5.value = false
}

// Restart animation function
const restartAnimation = () => {
    stopAnimation() // Stop current animation first
    setTimeout(() => {
        startAnimationSequence()
    }, 100)
}

// Cleanup on unmount
onUnmounted(() => {
    isAnimationRunning.value = false
    if (typingInterval) {
        clearInterval(typingInterval)
        typingInterval = null
    }
})

// Expose functions to parent component
defineExpose({
    stopAnimation,
    restartAnimation
})
</script>

<style scoped>
.third-shape-hero-section {
    width: 340px;
    height: 340px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle-animation-container {
    position: relative;
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle-effect {
    position: relative;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease-in-out;
}


.click-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #b6b6b6;
    border-radius: 50%;
    opacity: 0;
}

.circle-1 {
    width: 20px;
    height: 20px;
}

.circle-2 {
    width: 20px;
    height: 20px;
}

.circle-effect.active .circle-1 {
    animation: expand-circle-1 0.6s ease-out forwards;
}

.circle-effect.active .circle-2 {
    animation: expand-circle-2 0.6s ease-out forwards;
}

.click-indicator-icon {
    position: absolute;
    top: calc(50% + 4px);
    right: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    opacity: 0;
    transition: all 0.5s ease-in-out;
    pointer-events: none;
}


.click-indicator-icon.appear {
    animation: iconAppear 0.4s ease-out forwards;
}

@keyframes iconAppear {
    0% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.3);
    }

    50% {
        opacity: 0.8;
        transform: translate(-50%, -50%) scale(1.1);
    }

    100% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
}

/* Content Card Styles */
.content-card {
    position: absolute;
    top: calc(50% + 80px);
    right: 50%;
    transform: translate(50%, -50%);
    z-index: 1;
    opacity: 0;
    /* Initially hidden */
    transition: all 0.5s ease-in-out;
    /* Smooth transition */
}

.content-card.appear {
    opacity: 1;
    /* Appear when showCard is true */
}

/* Card Container */
.card-container {
    position: relative;
    width: 230px;
    height: 120px;
    background: #FFFFFF;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 11.88px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid rgba(238, 238, 238, 0.933333);
}

/* Card Background */
.card-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    border-radius: 11.88px;
    opacity: 0.1;
    /* Adjust as needed for background effect */
    z-index: -1;
}

/* Card Circle Effect */
.card-circle-effect {
    position: absolute;
    bottom: -8px;
    right: 2px;
    /* transform: translate(-50%, -50%); */
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    opacity: 0;
    pointer-events: none;
}

.card-circle-effect.active {
    opacity: 1;
    pointer-events: auto;
}

.card-click-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #b6b6b6;
    border-radius: 50%;
    opacity: 0;
}

.card-circle-1 {
    width: 15px;
    height: 15px;
}

.card-circle-2 {
    width: 15px;
    height: 15px;
}

.card-circle-effect.active .card-circle-1 {
    animation: card-expand-circle-1 0.6s ease-out forwards;
}

.card-circle-effect.active .card-circle-2 {
    animation: card-expand-circle-2 0.6s ease-out forwards;
}

@keyframes card-expand-circle-1 {
    0% {
        width: 15px;
        height: 15px;
        opacity: 1;
    }

    100% {
        width: 45px;
        height: 45px;
        opacity: 0;
    }
}

@keyframes card-expand-circle-2 {
    0% {
        width: 15px;
        height: 15px;
        opacity: 1;
    }

    50% {
        opacity: 1;
    }

    100% {
        width: 60px;
        height: 60px;
        opacity: 0;
    }
}

/* Card Content */
.card-content {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    text-align: center;
}

/* Arabic Text */
.card-title {
    color: #000000;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: start;
    margin-bottom: 10px;
    min-height: 45px;
}

/* Typing effect styles */
.typing-text {
    display: inline;
}

.typing-cursor {
    display: inline;
    color: #5854FF;
    font-weight: bold;
    animation: blink 1s infinite;
}

@keyframes blink {

    0%,
    50% {
        opacity: 1;
    }

    51%,
    100% {
        opacity: 0;
    }
}

/* Action Icons */
.action-icons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
}

/* Upload Icon */
.upload-icon {
    width: 24px;
    height: 24px;
}

/* Gallery Icon */
.gallery-icon {
    width: 24px;
    height: 24px;
    background: #5854FF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transition: all 0.3s ease;
}

.gallery-icon.show-check {
    background: #4CAF50;
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.check-icon {
    animation: checkAppear 0.4s ease-out;
}

@keyframes checkAppear {
    0% {
        opacity: 0;
        transform: scale(0.5) rotate(-10deg);
    }

    50% {
        opacity: 0.7;
        transform: scale(1.1) rotate(5deg);
    }

    100% {
        opacity: 1;
        transform: scale(1) rotate(0deg);
    }
}

.original-icon {
    transition: all 0.3s ease;
}

.gallery-icon.show-check .original-icon {
    opacity: 0;
    transform: scale(0.8);
}

/* New Icon Container */
.new-icon-container {
    position: absolute;
    width: 14px;
    height: 14px;
    opacity: 0;
    z-index: 30;
    transition: all 0.5s ease-in-out;
}

/* Icon 1 - Top Left */
.new-icon-container.icon-1 {
    top: calc(50% - 4px);
    left: calc(50% + -5px);
    transform: translate(-50%, -50%);
}

/* Icon 2 - Top Right */
.new-icon-container.icon-2 {
    top: 25%;
    right: 15%;
    transform: translate(50%, -50%);
}

/* Icon 3 - Bottom Left */
.new-icon-container.icon-3 {
    bottom: 30%;
    left: 25%;
    transform: translate(-50%, 50%);
}

/* Icon 4 - Bottom Right */
.new-icon-container.icon-4 {
    bottom: 20%;
    right: 20%;
    transform: translate(50%, 50%);
}

/* Icon 5 - Center */
.new-icon-container.icon-5 {
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.new-icon-container.appear {
    opacity: 1;
    animation: newIconAppear 0.8s ease-out;
}

@keyframes newIconAppear {
    0% {
        opacity: 0;
    }

    30% {
        opacity: 0.6;
    }

    60% {
        opacity: 0.9;
    }

    100% {
        opacity: 1;
    }
}

@keyframes expand-circle-1 {
    0% {
        width: 20px;
        height: 20px;
        opacity: 1;
    }

    100% {
        width: 60px;
        height: 60px;
        opacity: 0;
    }
}

@keyframes expand-circle-2 {
    0% {
        width: 20px;
        height: 20px;
        opacity: 1;
    }

    50% {
        opacity: 1;
    }

    100% {
        width: 80px;
        height: 80px;
        opacity: 0;
    }
}
</style>